import { render, staticRenderFns } from "./JobDetailSection.vue?vue&type=template&id=868842d6&scoped=true"
import script from "./JobDetailSection.vue?vue&type=script&lang=js"
export * from "./JobDetailSection.vue?vue&type=script&lang=js"
import style0 from "./JobDetailSection.vue?vue&type=style&index=0&id=868842d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868842d6",
  null
  
)

export default component.exports